// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
// 先引入第三方组件
import ElementUI from "element-ui";
import "./assets/style/theme/index.css";
// import "element-ui/lib/theme-chalk/index.css";
// 后引入自定义样式和router
import "../static/css/common.css";
import "../static/css/quill.core.css";
import "../static/css/quill.bubble.css";
import "../static/css/quill.snow.css";
import router from "./router";
import axios from "axios";
import library from "./js/library";
import consts from "./js/consts";
import "./assets/icon/iconfont.css";
import i18n from "./i18n";
import VueClipboards from "vue-clipboard2";
import watermark from "./js/watermark";


Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
});
Vue.config.productionTip = false;

Vue.use(VueClipboards);
Vue.prototype.$watermark = watermark;

// Vue.use(vueEsign)

// function getWebBaseUrl() {
//     return "http://127.0.0.1:9080";
//     // return 'http://47.100.27.141:9002';
// }

import htmlToPdfByPage from "@/js/htmlToPdfByPage";
Vue.use(htmlToPdfByPage);

Vue.prototype.$http = axios;
// Vue.prototype.$baseRestUrl = getWebBaseUrl();

// Vue.prototype.$http.defaults.baseURL = 'http://139.196.44.157:9000';
// Vue.prototype.$http.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
Vue.prototype.$http.defaults.timeout = 120000;

Vue.prototype.req = library.req;
Vue.prototype.reqCache = library.reqCache;
Vue.prototype.reqAsy = library.reqAsy;
Vue.prototype.export = library.export;
Vue.prototype.fmoney = library.fmoney;
Vue.prototype.funAuth = library.funAuth;
Vue.prototype.downLoad = library.downLoad;
Vue.prototype.envPath = library.envPath;
Vue.prototype.isImg = library.isImg;
Vue.prototype.isDoc = library.isDoc;
Vue.prototype.lib = library;

Vue.prototype.consts = consts;

// //引入echarts   sd
// import echarts from '/src/assets/echarts.min.js'
// Vue.prototype.$echarts = echarts

String.prototype.endWith = function(endStr) {
    var d = this.length - endStr.length;
    return d >= 0 && this.lastIndexOf(endStr) == d;
};
String.prototype.replaceAll = function(s1, s2) {
    return this.replace(new RegExp(s1, "gm"), s2);
};

Vue.filter("fmoney", library.fmoney);
Vue.filter("timeFormat", library.timeFormat);
Vue.filter("nameChar", library.nameChar);
Vue.filter("nameToColor", library.nameToColor);
Vue.filter("lastChar", library.lastChar);
Vue.filter("numToLetter", library.numToLetter);
Vue.filter("qstAnswerFmt", library.qstAnswerFmt);

Vue.component("loc-file-kit", () => import("@/plugins/locFileKit"));
Vue.component("chart-base", () => import("@/plugins/chartBase"));
Vue.component("chart-table", () => import("@/plugins/chartTable"));
Vue.component("top-nav", () => import("@/plugins/topNav"));
Vue.component("bot-nav", () => import("@/plugins/botNav"));

Vue.component("mobileTopNav", () => import("@/components/cust/comp/mobileTopNav"));
Vue.component("tabBar", () => import("@/components/cust/comp/tabBar"));
Vue.component("tabItem", () => import("@/components/cust/comp/tabItem"));

import * as filters from "./filters/index";
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});

/* eslint-disable no-new */
new Vue({
    el: "#app",
    router,
    i18n,
    data: function() {
        return {
            LOGINSTATUS: true
        };
    },
    components: { App },
    template: "<App/>",
    mounted: function() {
        this.$nextTick(function() {
            document.title = config.sysName;
        });
    }
});



// WEBPACK FOOTER //
// ./src/main.js